<ng-select
  class="ui-select {{ size() }}"
  [ngClass]="{ 'ui-select__language-selector': isLanguageSelector() }"
  [(ngModel)]="value"
  [items]="items()"
  [bindLabel]="bindLabel()"
  [placeholder]="placeholder() | translate"
  [clearable]="false"
  [searchable]="false"
  [closeOnSelect]="!multiple()"
  [dropdownPosition]="dropdownPosition()"
  [multiple]="multiple()"
  (blur)="onTouched()"
  (change)="onChange($event)"
  [class.invalid]="control()?.invalid && control()?.dirty"
>
  <ng-template ng-multi-label-tmp let-items="items">
    <div class="value-container">
      @for (item of items; track item) {
        <span class="value">{{ item.name }}</span>
      }
    </div>
  </ng-template>
</ng-select>

@if (control()?.invalid && control()?.dirty) {
  <ui-validation-message [errors]="control()?.errors" />
}
